import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=43c2c608&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c2c608')) {
      api.createRecord('43c2c608', component.options)
    } else {
      api.reload('43c2c608', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=43c2c608&", function () {
      api.rerender('43c2c608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NZOw29qBVuz/JS/cancellationPolicy.vue"
export default component.exports